import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Mantra from '../components/Mantra';
import InfoModal from '../components/InfoModal';
import FourOptions from '../components/FourOptions';
import AboutRImage from '../components/AboutRImage';
import Footer from '../components/Footer';
import CTA from "../components/CTA";
import ContentSection from '../components/ContentSection';
import '../styles/App.css';
import HeroImage from '../assets/images/HeroCoach.png';
import MantraImage from '../assets/images/Mantra_2.png';
import AboutRI from '../assets/images/AboutRI_Image.png';
import CTAImage from "../assets/images/CTA_Coach.png";



function Home() {
  // Example content for InfoModal
  const infoItems = [
	{ title: '1:1', description: 'Lifestyle of Fitness' },
	{ title: 'Family', description: 'Off-Season Development' },
	{ title: 'Small Groups', description: 'Pre-Season & In-Season' },
	{ title: 'Teams', description: 'Year-Round Training' },
  ];
  
  const CoWorkDetails = {
	items: [
	  {
		title: 'Why Choose our Co-working space?',
		subtitle1: 'What We Offer',
		body1: (
		  <>
			<ul>
			 <li>• Stay connected to your athletes while maintaining a professional workspace.</li>
			 <li>• Perfect for managing administrative tasks, program planning, or business growth.</li>
			 <li>• Conveniently located within the facility, so you’re never far from the gym floor.</li>
			</ul>
		  </>
		),
		subtitle2: 'What We Offer',
		body2: (
		  <>
			<ul>
			  <li>•	Cubicle Rental: Your own dedicated workspace in a shared open room.</li>
			  <li>•	Sound-Insulated: Large windows allow you to see the gym while keeping sound distractions to a minimum, so you can work uninterrupted.</li>
			  <li>•	Storage Solutions: A small file storage unit is included at each station, keeping everything organized and within reach.</li>
			  <li>•	Conference Room Access: Book the conference room for team meetings, strategy sessions, or private discussions.</li>
			  <li>•	Private Call Booths: Two Framery Smart Pods, are available for conference calls or video calls in a soundproof setting.</li>
			</ul>
		  </>
		),
	  },
	],
  };

  
  const fourOptionsContent = {
	sectionTitle: (
	  <>
		Why Choose <span style={{ color: 'red' }}>Begin?</span>
	  </>
	),
	sectionDescription:
	  'Our facility is designed to meet the needs of coaches and athletes alike, offering four specialized training areas:',
	options: [
	  {
		title: 'Professional Facilities',
		subtitle: 'Professional Facilities',
		body: 'Train your athletes in a collegiate-level NIKE Strength-equipped gym, complete with a regulation volleyball court, an outdoor turf field for dynamic drills, and a dedicated yoga and HIIT area.',
	  },
	  {
		title: 'Focus & Flexibility',
		subtitle: 'Focus & Flexibility',
		body: 'Whether you’re working with individual athletes, small groups, or entire teams, we offer packages tailored to your coaching needs. With add-ons like court reservations and co-working.',
	  },
	  {
		title: 'Support For Coaches',
		subtitle: 'Support For Coaches',
		body: 'We offer quarterly events to keep you motivated, inspired, and up-to-date. Our goal is to help you grow alongside your athletes, creating an environment where everyone thrives.',
	  },
	  {
		title: 'Co-Working',
		subtitle: 'Co-Working',
		body: 'We offer a limited number of seats in our co-working space, designed specifically for coaches who want to stay close to the action while having a home-base for planning and scheduling.',
	  },
	],
  };

  return (
	<div className="home">
	  <SEO
		title="For Coaches"
		description="A facility designed for coaches who need a home gym to train their athletes in strength and fitness. Professional equipment and flexible scheduling."
		image="/og-images/coach.png"
		path="/coach"
	  />
	  <Header />
	  <main>
		<Hero
		  backgroundImage={HeroImage}
		  headerText={
			<>
			  Are You A<br /><span style={{ color: 'red' }}>Coach?</span>
			</>
		  }
		  paragraphText={
			<>
			  <p>
				We know the challenges coaches face in finding the right space to train their athletes.
			  </p>
			  <p>
				That’s why we’ve created a facility that feels like your home gym—a place where coaches can bring their athletes to excel in strength, fitness, and skill development. Whether you’re coaching a small group, leading a team, or working one on one with athletes, our facility is designed to meet your needs and elevate your athletes’ performance.
			  </p>
			</>
		  }
		  primaryButtonText="Plans & Pricing"
		  primaryButtonLink="/plans"
		/>
		<InfoModal items={infoItems} />
		<FourOptions
		  sectionTitle={fourOptionsContent.sectionTitle}
		  sectionDescription={fourOptionsContent.sectionDescription}
		  options={fourOptionsContent.options}
		/>
		
		<CTA
		  title={
			<>
			Interested In <span style={{ color: 'red' }}>Co-working?</span>
			</>
			}
		  description={
		  <>
		  <p>Need a professional “home base” outside of your home?</p>
		  
		  <p>We offer a limited number of seats in our co-working space, designed specifically for coaches, trainers, and professionals who want to stay close to the action while maintaining focus and privacy.</p>
		  
		  <p>Seats are limited! If you’re interested in securing your spot in our co-working space, don’t wait—schedule a tour today.</p>
		  </>
		}
		  imageSrc={CTAImage}
		  primaryButtonText="Send Info"
		  primaryButtonLink="#"
		/>
		<ContentSection  
		  items={CoWorkDetails.items}
		  sectionClass="faq-sub-section"
		  showNumbers={false}
		/>
		<AboutRImage
		  title={
		  <>
		  Frequently Asked <span style={{ color: 'red' }}>Questons</span>
		  </>
		  }
		  
		  copy={
			<>
				<p>We know coaches have plenty of questions when it comes to finding the right facility to train their athletes. </p> 
				
				<p>Whether you’re curious about our facility size, coaching philosophy, insurance requirements, hours of operation, or other details, we’re here to help. Our FAQs section is designed to give you clear and concise answers to the most common questions we receive. If you don’t see what you’re looking for, feel free to reach out—we’d love to connect and provide the information you need!</p>
			</>
		  }
		  imageSrc={AboutRI}
		  primaryButtonText="About Us"
		  primaryButtonLink="/about"
		/>
		<Mantra
		  backgroundImage={MantraImage}
		  mantraText="BEGIN BEGUN BEGIN AGAIN"
		/>
		<Footer />
	  </main>
	</div>
  );
}

export default Home;